import axios from "axios";

let env = process.env.NODE_ENV;

let API_URL = "https://middleware.veloe.com.br";
let CHECK_CODE = `${API_URL}/publico/campanhas`;
let FC_FLOW_PRE_URL = "https://veloe.com.br/planos/total-pre";
let FC_FLOW_POS_URL = "https://veloe.com.br/planos/total-pos";
let FC_FLOW_ESTRADA_PRE_URL = "https://veloe.com.br/planos/estrada-pre";
let FC_FLOW_CIDADE_PRE_URL = "https://veloe.com.br/planos/cidade-pre";
let WHITELIST_URL = `${API_URL}/publico/whitelist`;
let VELOE_URL = "https://veloe.com.br/sobre";
let API_CAMPANHA_URL = "https://api.veloe.com.br/campanhas/v1";

if (window.location.href) {
  if (window.location.href.indexOf("localhost") > -1) env = "local";
  else if (window.location.href.indexOf("hml") > -1) env = "hml";
  else if (window.location.href.indexOf("dev") > -1) env = "dev";
}

if (env === "local") {
  API_URL = "http://localhost:3000";
  CHECK_CODE = `${API_URL}/publico/campanhas`;
  FC_FLOW_PRE_URL = "http://localhost:3000/planos/total-pre";
  FC_FLOW_POS_URL = "http://localhost:3000/planos/total-pos";
  FC_FLOW_ESTRADA_PRE_URL = "https://localhost:3000/planos/estrada-pre";
  FC_FLOW_CIDADE_PRE_URL = "https://localhost:3000/planos/cidade-pre";
  WHITELIST_URL = "http://localhost:3001/publico/whitelist";
  VELOE_URL = "http://localhost:3000/sobre";
  API_CAMPANHA_URL = "https://hml.api.veloe.com.br/campanhas/v1";
} else if (env === "dev") {
  API_URL = "http://localhost:3000";
  CHECK_CODE = `${API_URL}/publico/campanhas`;
  FC_FLOW_PRE_URL = "http://localhost:3000/planos/total-pre";
  FC_FLOW_POS_URL = "http://localhost:3000/planos/total-pos";
  FC_FLOW_ESTRADA_PRE_URL = "https://localhost:3000/planos/estrada-pre";
  FC_FLOW_CIDADE_PRE_URL = "https://localhost:3000/planos/cidade-pre";
  WHITELIST_URL = "http://localhost:3001/publico/whitelist";
  VELOE_URL = "http://localhost:3000/sobre";
} else if (env === "hml") {
  API_URL = "https://middleware.hml.fastalelo.com";
  CHECK_CODE = `${API_URL}/publico/campanhas`;
  FC_FLOW_PRE_URL = "https://hml.fastalelo.com/planos/total-pre";
  FC_FLOW_POS_URL = "https://hml.fastalelo.com/planos/total-pos";
  FC_FLOW_ESTRADA_PRE_URL = "https://hml.fastalelo.com/planos/estrada-pre";
  FC_FLOW_CIDADE_PRE_URL = "https://hml.fastalelo.com/planos/cidade-pre";
  WHITELIST_URL = `${API_URL}/publico/whitelist`;
  VELOE_URL = "https://hml.fastalelo.com/sobre";
  API_CAMPANHA_URL = "https://hml.api.veloe.com.br/campanhas/v1";
}

export {
  CHECK_CODE,
  FC_FLOW_PRE_URL,
  FC_FLOW_POS_URL,
  FC_FLOW_ESTRADA_PRE_URL,
  FC_FLOW_CIDADE_PRE_URL,
  WHITELIST_URL,
  VELOE_URL,
};

export const api = axios.create({
  baseURL: API_URL,
});

export const apiCampanha = axios.create({
  baseURL: API_CAMPANHA_URL,
});

export const getPlans = async (code) => {
  if (!code || code === "") return null;
  const types = ["PRE", "POS", "EST", "CID"];

  const plans = await Promise.all(
    types.map(async (type) => {
      const url = `/publico/campanhas/${code}${type}`;
      const response = await api
        .get(url)
        .then((res) => res.data[0])
        .catch((err) => err);
      return response;
    })
  );

  if (plans.every((plan) => plan.isAxiosError)) return null;

  if (code.includes("RODOSOL")) return plans.filter((_, index) => index < 2);

  return plans;
};
